export default {
  baseStyle: {
    color: "brand.white",
    textTransform: "uppercase",
  },
};
